"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "venezia": {
    "lido-di-venezia-periferia": [{
      "hkey": "07aa6b40",
      "slug": "alberoni-lido-malamocco-pellestrina",
      "name": "Alberoni, Lido, Malamocco, Pellestrina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "40e1e61b": [{
      "hkey": "07aa6b40",
      "slug": "alberoni-lido-malamocco-pellestrina",
      "name": "Alberoni, Lido, Malamocco, Pellestrina",
      "primary": true,
      "skipSearch": false
    }],
    "af9570d6": [{
      "hkey": "07aa6b40",
      "slug": "alberoni-lido-malamocco-pellestrina",
      "name": "Alberoni, Lido, Malamocco, Pellestrina",
      "primary": true,
      "skipSearch": false
    }],
    "burano": [{
      "hkey": "3edceb53",
      "slug": "burano-mazzorbo-torcello",
      "name": "Burano, Mazzorbo, Torcello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "murano": [{
      "hkey": "53f4c1f3",
      "slug": "le-vignole-murano-sant-erasmo",
      "name": "Le Vignole, Murano, Sant'Erasmo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "542c6d99": [{
      "hkey": "f9975257",
      "slug": "zelarino",
      "name": "Zelarino",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "97815bb3",
      "slug": "san-marco-rialto-san-polo",
      "name": "San Marco, Rialto-San Polo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "26170914": [{
      "hkey": "0791733e",
      "slug": "asseggiano-gazzera-chirignago-zelarino",
      "name": "Asseggiano-Gazzera, Chirignago, Zelarino",
      "primary": true,
      "skipSearch": false
    }],
    "san-polo": [{
      "hkey": "97815bb3",
      "slug": "san-marco-rialto-san-polo",
      "name": "San Marco, Rialto-San Polo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "marghera": [{
      "hkey": "ddfb20bc",
      "slug": "marghera-catene-fusina-malcontenta",
      "name": "Marghera, Catene, Fusina, Malcontenta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e823c581": [{
      "hkey": "06198e2e",
      "slug": "campalto-favaro-veneto",
      "name": "Campalto, Favaro Veneto",
      "primary": true,
      "skipSearch": false
    }],
    "ac022867": [{
      "hkey": "bbd3a9a1",
      "slug": "accademia-salute-dorsoduro-san-barnaba-santa-marta",
      "name": "Accademia-Salute, Dorsoduro-San Barnaba, Santa Marta",
      "primary": true,
      "skipSearch": false
    }],
    "favaro-veneto": [{
      "hkey": "06198e2e",
      "slug": "campalto-favaro-veneto",
      "name": "Campalto, Favaro Veneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "lido": [{
      "hkey": "07aa6b40",
      "slug": "alberoni-lido-malamocco-pellestrina",
      "name": "Alberoni, Lido, Malamocco, Pellestrina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "lido-di-venezia-centro": [{
      "hkey": "07aa6b40",
      "slug": "alberoni-lido-malamocco-pellestrina",
      "name": "Alberoni, Lido, Malamocco, Pellestrina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5e181d69": [{
      "hkey": "97815bb3",
      "slug": "san-marco-rialto-san-polo",
      "name": "San Marco, Rialto-San Polo",
      "primary": true,
      "skipSearch": false
    }],
    "8155b36f": [{
      "hkey": "53f4c1f3",
      "slug": "le-vignole-murano-sant-erasmo",
      "name": "Le Vignole, Murano, Sant'Erasmo",
      "primary": true,
      "skipSearch": false
    }],
    "91ac37bb": [{
      "hkey": "97815bb3",
      "slug": "san-marco-rialto-san-polo",
      "name": "San Marco, Rialto-San Polo",
      "primary": true,
      "skipSearch": false
    }],
    "dorsoduro": [{
      "hkey": "bbd3a9a1",
      "slug": "accademia-salute-dorsoduro-san-barnaba-santa-marta",
      "name": "Accademia-Salute, Dorsoduro-San Barnaba, Santa Marta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cannaregio": [{
      "hkey": "7f3c66a9",
      "slug": "guglie-san-leonardo-santi-apostoli-san-canciano",
      "name": "Guglie-San Leonardo, Santi Apostoli-San Canciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e78da72b": [{
      "hkey": "3edceb53",
      "slug": "burano-mazzorbo-torcello",
      "name": "Burano, Mazzorbo, Torcello",
      "primary": true,
      "skipSearch": false
    }],
    "3f1a6110": [{
      "hkey": "0791733e",
      "slug": "asseggiano-gazzera-chirignago-zelarino",
      "name": "Asseggiano-Gazzera, Chirignago, Zelarino",
      "primary": true,
      "skipSearch": false
    }],
    "asseggiano-gazzera-chirignago": [{
      "hkey": "0791733e",
      "slug": "asseggiano-gazzera-chirignago-zelarino",
      "name": "Asseggiano-Gazzera, Chirignago, Zelarino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "65ea8732": [{
      "hkey": "59238a14",
      "slug": "mestre",
      "name": "Mestre",
      "primary": true,
      "skipSearch": false
    }],
    "bissuola-carpenedo": [{
      "hkey": "59238a14",
      "slug": "mestre",
      "name": "Mestre",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "venezia"
    }],
    "cipressina-zelarino": [{
      "hkey": "f9975257",
      "slug": "zelarino",
      "name": "Zelarino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "asseggiano-gazzera-chirignago-zelarino"
    }],
    "92234a4b": [{
      "hkey": "64ae9a62",
      "slug": "cipressina",
      "name": "Cipressina",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "f9975257",
      "slug": "zelarino",
      "name": "Zelarino",
      "primary": true,
      "skipSearch": false
    }],
    "5139daef": [{
      "hkey": "2ee2f0e8",
      "slug": "bissuola",
      "name": "Bissuola",
      "primary": true,
      "skipSearch": false
    }],
    "bissuola": [{
      "hkey": "2ee2f0e8",
      "slug": "bissuola",
      "name": "Bissuola",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "mestre"
    }],
    "080e63fe": [{
      "hkey": "f7e045fc",
      "slug": "carpenedo",
      "name": "Carpenedo",
      "primary": true,
      "skipSearch": false
    }],
    "carpenedo": [{
      "hkey": "f7e045fc",
      "slug": "carpenedo",
      "name": "Carpenedo",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "mestre"
    }],
    "f984d742": [{
      "hkey": "64ae9a62",
      "slug": "cipressina",
      "name": "Cipressina",
      "primary": true,
      "skipSearch": false
    }],
    "cipressina": [{
      "hkey": "64ae9a62",
      "slug": "cipressina",
      "name": "Cipressina",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "mestre"
    }],
    "8ba6befb": [{
      "hkey": "f9975257",
      "slug": "zelarino",
      "name": "Zelarino",
      "primary": true,
      "skipSearch": false
    }],
    "zelarino": [{
      "hkey": "f9975257",
      "slug": "zelarino",
      "name": "Zelarino",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "asseggiano-gazzera-chirignago-zelarino"
    }],
    "santa-croce": [{
      "hkey": "97815bb3",
      "slug": "san-marco-rialto-san-polo",
      "name": "San Marco, Rialto-San Polo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1eeeb7e7": [{
      "hkey": "07aa6b40",
      "slug": "alberoni-lido-malamocco-pellestrina",
      "name": "Alberoni, Lido, Malamocco, Pellestrina",
      "primary": true,
      "skipSearch": false
    }],
    "4b1f5cb4": [{
      "hkey": "97815bb3",
      "slug": "san-marco-rialto-san-polo",
      "name": "San Marco, Rialto-San Polo",
      "primary": true,
      "skipSearch": false
    }],
    "3959b4d8": [{
      "hkey": "ddfb20bc",
      "slug": "marghera-catene-fusina-malcontenta",
      "name": "Marghera, Catene, Fusina, Malcontenta",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "584e5af5",
      "slug": "santa-maria-formosa-santi-giovanni-e-paolo",
      "name": "Santa Maria Formosa, Santi Giovanni e Paolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "chirignago": [{
      "hkey": "0791733e",
      "slug": "asseggiano-gazzera-chirignago-zelarino",
      "name": "Asseggiano-Gazzera, Chirignago, Zelarino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f32ebf1c": [{
      "hkey": "584e5af5",
      "slug": "santa-maria-formosa-santi-giovanni-e-paolo",
      "name": "Santa Maria Formosa, Santi Giovanni e Paolo",
      "primary": true,
      "skipSearch": false
    }],
    "f4e8ac27": [{
      "hkey": "7f3c66a9",
      "slug": "guglie-san-leonardo-santi-apostoli-san-canciano",
      "name": "Guglie-San Leonardo, Santi Apostoli-San Canciano",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;